import { RouteConfig } from "vue-router";

export const RNewTasksBrowse: RouteConfig = {
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "tasks-browse" */
      "./VTasksList.vue"
    ),
  meta: {
    title: "Tasks",
  },
};
